import { render, staticRenderFns } from "./PollQuestion.vue?vue&type=template&id=40c33c3c&lang=pug&"
import script from "./PollQuestion.vue?vue&type=script&lang=js&"
export * from "./PollQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports